// Lightbox für Bilder im "Wristcheck" in der Seitenleiste von Uhren
import baguetteBox from 'baguettebox.js';

const wristcheckLightbox = {
    init() {
        if (document.querySelector('.js-wristcheck-lightbox')) {
            baguetteBox.run('.js-wristcheck-lightbox', {
                noScrollbars: true,
            });
        }
    },
};

export default wristcheckLightbox;
